<template>
  <div class="page-header">
    <div class="d-flex align-items-center">
      <b-button v-if="showBack" variant="link" class="back-chevron p-0 mr-2" @click="$router.go(-1)">
        <i class="material-icons">chevron_left</i>
      </b-button>
      <h2>{{ title }}</h2>
    </div>
    <div>
      <slot name="actions">
        <b-button
          v-if="buttonLabel"
          :variant="buttonVariant"
          :to="buttonPath"
          @click="$emit('click')"
        >
          {{ buttonLabel }}
        </b-button>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageHeader',
  props: {
    title: { type: String, required: true },
    buttonLabel: { type: String, default: '' },
    buttonPath: { type: [String, Object], default: '' },
    buttonVariant: { type: String, default: 'primary' },
    showBack: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.back-chevron {
  color: #181818 !important;
  text-decoration: none !important;
  line-height: 1;
}
.back-chevron .material-icons {
  font-size: 2rem;
}
.back-chevron:hover {
  opacity: 0.6;
}
</style>
